import { ONBOARDING_DIALOG_CLASS_NAME } from "@constants";
import { _MemberSettingOnboardDialogLayout } from "@types";
import { DialogClasses, Drawer, DrawerClasses } from "kz-ui-sdk";
import { PropsWithChildren } from "react";
import { DialogFullPage } from "./components";

interface DialogControllerProps extends PropsWithChildren {
  layout: _MemberSettingOnboardDialogLayout;
  isOpen: boolean;
  onClose: () => void;
  classes?: {
    drawer?: DrawerClasses["classes"];
    dialog?: DialogClasses["classes"];
  };
}

export const DialogController = ({ children, layout, isOpen, onClose, classes }: DialogControllerProps) => {
  if (layout === _MemberSettingOnboardDialogLayout.DIALOG_DRAWER) {
    return (
      <Drawer
        open={isOpen}
        onClose={onClose}
        safeZone
        classes={classes?.drawer}
        className={ONBOARDING_DIALOG_CLASS_NAME}
      >
        {children}
      </Drawer>
    );
  }

  if (layout === _MemberSettingOnboardDialogLayout.DIALOG_PAGE) {
    return (
      <DialogFullPage
        open={isOpen}
        className={ONBOARDING_DIALOG_CLASS_NAME}
      >
        {children}
      </DialogFullPage>
    );
  }
};
